
import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import  NuDropdown from "components/nubox/NuDropdown"; 
import NuCheckbox from "components/nubox/NuCheckbox"

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";

import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';
import NuListSearch from 'components/nubox/NuListSearch';


const data1 = [
  { value: 1, label: "Apple" },
  { value: 2, label: "Facebook" },
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class HabLlenadoNotas extends React.Component {  

  
  
  state = {
    modalInsertar: false,
    
        
    form: {
      id_doc:0,
      id_mate:0,
      b1_cerrado_sn:0,
      b2_cerrado_sn:0,
      b3_cerrado_sn:0,
      b4_cerrado_sn:0,
      final_cerrado:0,
    },

    data: [],
    item_selected:{},
    materias: [],
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
    //this.modalRef = React.createRef();//create ref
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    //this.setState({data:[]});

    this.cargar_docentes();
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  handleChangeFormDoc =(e)=>{
    //--tenemos que cargar el 2do combo
    let id_doc = e.target.value
    this.cargar_materias_doc(id_doc)
    //------------
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  }
  //------------
  //------------
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  //------------------------
  limpiar=()=>{
    this.setState({form:{ 
      //id_doc: this.state.item_selected.value,
      nueva_clave: "",
      confirmar_clave:'',
    }}); /*ojo */ 
  }
   //-----------------
   cargar_docentes = async() => {
    let param = { }
    
    await axios2.post("cbo_docente", param).then(res => {
        if(res.data.length>0){ 
            this.setState({data: res.data})
            /*let id_doc = res.data[0].value
            this.setState({item_selected: res.data[0]})
            this.setState({form:{...this.state.form, id_doc: res.data[0].value}}); 
            */
            //---cuando cargue, cargamos 2do cbo
            //this.cargar_materias_doc(id_doc)
        }else{
          this.setState({data: []})
          this.setState({form:{...this.state.form, id_doc: 0 }}); /*ojo */ 
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //--------------------------
  //-----------------
  cargar_materias_doc = async(id_doc) => {
    let param = { 
        id_doc: id_doc,
    }
    
    await axios2.post("cbo_materia_docente", param).then(res => {
        if(res.data.length>0){ 
          this.setState({materias: res.data})
          //this.setState({item_selected: res.data[0]})
          this.setState({form:{...this.state.form, id_mate: res.data[0].value}}); /*ojo */ 
        }else{
          this.setState({materias: []})
          this.setState({form:{...this.state.form, id_mate: 0 }}); /*ojo */ 
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //--------------------------
  
  //====================================================== 

  //-----------------------------------------------------------------
  onSubmitHandler= (event)=>{
    event.preventDefault();

    //this.save_confirm();
    this.buscar();
  }
  //-----------------------------------------------------------------
  /*save_confirm = () =>{
    console.log('save');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de save?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        //let idd = item.id_doc;
        //this.modalRef.current.save(idd);
        this.save();
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }*/
  //-----------------------------------
  //-----------------------------------
  buscar =() =>{
    const user = this.props.store.user;
    //const id_paciente = this.props.store.paciente.id_paciente;
    // ...this.state.form,
    let param = {
                id_doc : this.state.form.id_doc,
                id_mate : this.state.form.id_mate,
                id_peri: user.id_peri,
                };
    console.log(param);
    
    axios2.post("hab_llenado_notas_find_obj", param)
    .then(res => {
        console.log(res.data);
        if(res.data !== ""){ 
            toast.success("Registo Encontrado");   
            //this.limpiar();         
            this.setState({form: res.data })
        }else{
            toast.error("Registro no encontrado");
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    //const id_paciente = this.props.store.paciente.id_paciente;

    let param = {
                ...this.state.form,
                id_u: user.id_u,
                };
    console.log(param);

    axios2.post("hab_llenado_notas_save", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            toast.success(res.data.mensaje);   
            //this.limpiar();         
        }else{
            toast.error(res.data.mensaje);
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------
  //-------------------------------------
  render() {
  
    return (
      <div>
      
        { 
        
          //JSON.stringify( this.state.form )
        }
        <div className="content">

          <div className="row justify-content-center">
            <div className=" " style={{width: 480}}>
              <h3>Habilitar llenado de notas </h3>
              
              <form onSubmit={ this.onSubmitHandler}>

                <div className="card h-100 ">
                  <div className="card-header bg_azul1">
                    <span className="card-title text-white  ">
                      Buscar Materia
                    </span>
                  </div>

                  <div className="card-body bg_celeste3">


                    <table width="100%" align="center" className='tabla_basic'>
                      <tbody>
                        <tr>
                          <td width="25%" align="right">Docente:</td>
                          <td>
                            <NuDropdown 
                              options={this.state.data}
                              name="id_doc"
                              value={this.state.form.id_doc}
                              onChange={this.handleChangeFormDoc}
                              option0={true}
                              
                            />
                          </td>
                        </tr>
                        <tr>
                          <td  align="right">Materia:</td>
                          <td>
                            <NuDropdown 
                              options={this.state.materias}
                              name="id_mate"
                              value={this.state.form.id_mate}
                              onChange={this.handleChangeForm}
                            />
                          </td>
                        </tr>
                        

                        <tr bgcolor="cccccc" align="center">

                          <td colSpan="2">
                            
                          </td>
                        </tr>

                      </tbody>
                    </table>

                    <div align="center">

                      <Button className="btn  btn-primary">Buscar</Button>
                    </div>

                  </div>

                  <div id="divres"></div>

                </div>

              </form>
            </div>
            {/*<!-- ---------------->*/}


          </div>

          <br/>
          <div className="row justify-content-center">
            <div className=" " style={{width: 450}}>
              <div className="card h-100 ">
                <table width="100%" align="center" className='tabla_celeste'>
                  <thead>
                    <tr>
                      <th width="40%" className='text-center' align="right">Nota</th>
                      <th className='text-center'>¿Cerrado?</th>
                    </tr>
                  </thead>
                  <tbody>
                    
                    <tr>
                          <td align="right">Bimestre 1:</td>
                          <td>
                            <NuCheckbox
                              label=""
                              name="b1_cerrado_sn"
                              value={this.state.form.b1_cerrado_sn}
                              onChange={ this.handleChangeForm }

                            />
                          </td>
                        </tr>
                        <tr>
                          <td align="right">Bimestre 2:</td>
                          <td>
                          <NuCheckbox
                              label=""
                              name="b2_cerrado_sn"
                              value={this.state.form.b2_cerrado_sn}
                              onChange={ this.handleChangeForm }
                            />
                             
                          </td>
                        </tr>
                        <tr>
                          <td align="right">Bimestre 3:</td>
                          <td>
                          <NuCheckbox
                              label=""
                              name="b3_cerrado_sn"
                              value={this.state.form.b3_cerrado_sn}
                              onChange={ this.handleChangeForm }
                            />
                             
                          </td>
                        </tr>
                        <tr>
                          <td align="right">Bimestre 4:</td>
                          <td>
                          <NuCheckbox
                              label=""
                              name="b4_cerrado_sn"
                              value={this.state.form.b4_cerrado_sn}
                              onChange={ this.handleChangeForm }
                            />
                             
                          </td>
                        </tr>
                        <tr>
                          <td align="right">Planilla Final:</td>
                          <td>
                          <NuCheckbox
                              label=""
                              name="final_cerrado"
                              value={this.state.form.final_cerrado}
                              onChange={ this.handleChangeForm }
                            />
                             
                          </td>
                        </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2} className='text-center' style={{ backgroundColor: 'rgb(223 222 222)' }} >
                        <Button className="btn  btn-primary" onClick={ this.save }>Guardar</Button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        
        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      </div>
    );
  }
}
//------------para que soporte la funcionalidad de parametros

export default withRouterJim (HabLlenadoNotas);